"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PatchWorkspaceSecretRequest = void 0;
var PatchWorkspaceSecretRequest_1 = require("./PatchWorkspaceSecretRequest");
Object.defineProperty(exports, "PatchWorkspaceSecretRequest", { enumerable: true, get: function () { return PatchWorkspaceSecretRequest_1.PatchWorkspaceSecretRequest; } });
